module.exports = __webpack_public_path__ + "static/media/image8.ae30da91.jpg";